import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import './../../assets/GochiKid/scss/app.css';

const GochiKidStyles = () => (<React.Fragment />);

export default GochiKidStyles;